export default "__VITE_ASSET__C6i2AVx8__"